//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import EventPost from '~/components/events/event-post.vue'
import Newsletter from '~/components/events/Newsletter.vue'
import EventsBottom from '~/components/events/event-bottom.vue'
/* import APIloading from '~/components/common/APILoading.vue'
import APIFailed from '~/components/common/APIFailed.vue' */
import FooterTop from '~/components/footer/footerTop.vue'

export default {
  components: {
    TopScreen,
    EventPost,
    Newsletter,
    EventsBottom,
    /* APIloading,
    APIFailed */
    FooterTop
  },
  data () {
    return {
      faq: [],
      fetched: false,
      fetchError: false,
      events: [
        {
          id: 4,
          startDate: '2023-04-12',
          endDate: '2023-04-15',
          place: 'Hong Kong',
          title: 'Web3 Festival HONG KONG',
          description: 'We will be waiting for you at the Hong Kong Web 3 Festival 2023!<br>Come meet our team at booth G21!<br>Your presence would be awesome!',
          img: require('@/assets/img/events/event-4.jpg'),
          link: 'https://www.linkedin.com/company/pagsmile',
          showBooking: false
        },
        {
          id: 3,
          startDate: '2023-03-07',
          endDate: '2023-03-09',
          place: 'Berlin',
          title: 'ITB Berlin',
          description: 'Come meet our team and learn more about our solutions! We\'ll be waiting for you at Hall 6.1, 153 , from March 7 to 9!',
          img: require('@/assets/img/events/event-3.jpg'),
          link: 'https://www.linkedin.com/company/pagsmile',
          showBooking: false,
          pastEvent: true
        },
        {
          id: 2,
          startDate: '2023-02-07',
          endDate: '2023-02-09',
          place: 'London',
          title: 'Ice London',
          description: 'Come meet our team and learn more about our solutions! We\'ll be waiting for you at booth N9-261, from February 7 to 9!',
          img: require('@/assets/img/events/event-2.jpg'),
          link: 'https://www.linkedin.com/company/pagsmile',
          showBooking: false,
          pastEvent: true
        },
        {
          id: 1,
          startDate: '2022-06-07',
          endDate: '2022-06-09',
          place: 'Cyprus',
          title: 'iFX Cyprus',
          description: 'We’ll be at iFX Cyprus in person. Book a 1-on-1 with our specialists to find out how we can add more payment options to your checkout.',
          img: require('@/assets/img/events/event-1.jpg'),
          showBooking: false,
          pastEvent: true
        }
      ]
    }
  },
  /* async fetch () {
    try {
      const posts = await fetch('https://admin.pagsmile.com/index/api/faq.html')
        .then(res => res.json())
        .catch(function (e) {
          console.log(e)
        })
      let filteredPosts = []
      // console.log(posts)
      if (posts.length) {
        const locale = this.$i18n.locale
        if (locale === 'en') {
          filteredPosts = posts.filter(post => (post.lang_id === 2 && post.status === 1)) || []
        }
        if (locale === 'pt') {
          filteredPosts = posts.filter(post => (post.lang_id === 3 && post.status === 1)) || []
        }
        if (locale === 'zh') {
          filteredPosts = posts.filter(post => (post.lang_id === 1 && post.status === 1)) || []
        }
        if (locale === 'es') {
          filteredPosts = posts.filter(post => (post.lang_id === 4 && post.status === 1)) || []
        }
      }
      this.fetched = true
      if (filteredPosts.length) {
        this.faq = filteredPosts
        return
      } else {
        // Default to english language
        filteredPosts = posts.filter(post => (post.lang_id === 2 && post.status === 1)) || []
        if (filteredPosts.length) {
          this.faq = filteredPosts
          return
        }
      }
      this.faq = []
    } catch (err) {
      console.log('err', err)
      this.posts = []
      this.fetched = true
      this.fetchError = true
    }
  }, */
  // fetchOnServer: false,
  head () {
    return {
      title: this.$t('header-menu-events').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  mounted () {
    // this.clientFetch()
  },
  methods: {
    /* clientFetch () {
      this.$fetch()
    } */
  }
}
